import './style.css';
import { Link } from 'react-router-dom';
import { departments, jobs } from '../../../../../../../../../components/jobs-departments';

export default function Crew( { crew } ) {

    const image_path = 'https://image.tmdb.org/t/p/w138_and_h175_face';

    return (
        <div className='container-crew'>
            {(crew && crew?.length >= 1) &&
                <div id='div-elenco'>
                    <h2 className="h2-elenco-details-movie h2-titulo-sections" id="h2-sugestoes">Equipe de Produção</h2>
                    <div className='content-crew'>
                        {crew?.slice(0, 100).map((crew_data, key) =>{
                            return(
                                <Link to={`/pessoa/${crew_data?.id}/bg=movie/filmes`} className='people-crew' key={key}>
                                    <img loading="lazy" src={crew_data?.profile_path ? (`${image_path}${crew_data?.profile_path}`) : 'https://dflix.netlify.app/imagens/img-avatar.png'} alt={crew_data?.name} onError={({ currentTarget }) => {currentTarget.onerror = null; currentTarget.src='https://dflix.netlify.app/imagens/img-avatar.png';}}/>
                                    <section className='section-info-crew'>
                                        {crew_data?.original_name && 
                                            <span className='nome-ator'>{crew_data?.original_name}</span>
                                        }
                                        <span className='nome-personagem'>{departments[crew_data?.department]}</span>
                                        <span className='nome-personagem'>{jobs[crew_data?.job]}</span>
                                    </section>
                                </Link>
                            )
                        })}
                    </div>
                </div>
            }
        </div>
    )
}